import React from 'react'
import { SectionContainerImage } from "../common/sections/SectionContainerImage";
import { HeaderSection } from '../common/headers/HeaderSection'
import CardWhyStudyInAccelist from '../common/card/CardWhyStudyInAccelist'

export const SectionWhyStudyInAccelist = () => {
    return (
        <SectionContainerImage id='why-study-in-accelist-indonesia' additionalClassName='!py-0 -mt-6'>
            <div className="relative w-full h-full">
                <div className="relative -top-3 h-full w-full bg-cover bg-no-repeat bg-center" style={{ backgroundImage: "url('img/home/why-study-in-accelist.png')" }}>
                    <div className=" bg-secondary-100/90">
                        <div className='pt-6'>
                            <HeaderSection darkMode title='Mengapa Belajar di Accelist Edukasi Indonesia' subtitle='' />
                            <div className="flex flex-wrap px-8 md:px-16 pb-10 -mt-16">
                                <div className='w-full grid grid-cols-2 md:grid-cols-4 mt-12 md:mt-0'>
                                    <CardWhyStudyInAccelist title={'Berbasis Project'} imageSrc='img/home/project-based.png' subtitle={'Kami menyediakan program pelatihan  yang berbasis proyek untuk membantu siswa belajar lebih efektif.'} />
                                    <CardWhyStudyInAccelist title={'Support System'} imageSrc='img/home/support-system.png' subtitle={'Kami memastikan setiap siswa mendapatkan dukungan maksimal selama proses belajar melalui mentor yang berpengalaman dan komunitas yang aktif.'} />
                                    <CardWhyStudyInAccelist title={'Tim Instruktur Berkualitas'} imageSrc='img/home/qualified-instructor-team.png' subtitle={'Tim instruktur kami terdiri dari ahli di bidang teknologi informasi yang memiliki pengalaman praktis yang luas.'} />
                                    <CardWhyStudyInAccelist title={'Terhubung dengan Partners'} imageSrc='img/home/partners.png' subtitle={'Setelah lulus, kamu akan dibimbing untuk mempersiapkan karir dan mendapatkan pekerjaan di antara hiring partners Accelist Edu.'} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SectionContainerImage>
    )
}
